/**
 * Sets cookie
 */
export function setCookie(name:string, value:string | number, days: number) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    name +
    "=" +
    value +
    "; domain=" +
    window.location.hostname +
    "; expires=" +
    expires +
    "; path=/";
}

/**
 * Gets cookie
 */
export function getCookie(name:string):string {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/**
 * Removes a cookie
 * @param name Cookie name
 */
export function eraseCookie(name:string) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

/**
 * Print number with spaces
 * @param x
 */
export function numberWithSpaces(x:number): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

/**
 * Print float number with spaces
 * @param x
 * @returns
 */
export function floatNumberWithSpaces(x:number) {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(".");
}

// Mail functions
/**
 * Sends mail with form data
 * @param formdata
 */
export function sendMail(formdata: FormData, where = "/mail.php"):Promise<Response> {
  if (typeof Comagic == "object") {
    var credentials = Comagic.getCredentials();
    formdata.append("comagic", JSON.stringify(credentials));
  }
  return fetch(where, {
    method: "POST",
    body: formdata,
  });
}

// Mail functions
/**
 * Sends mail with form data
 * @param json
 */
export function sendMailJSON(json:any, where = "/mailjson.php"):Promise<Response> {
  if (typeof window.Comagic == "object") {
    var credentials = Comagic.getCredentials();
    json.comagic = JSON.stringify(credentials);
  }
  return fetch(where, {
    method: "POST",
    body: JSON.stringify(json),
    headers: {
      "Content-Type": "application/json",
    },
  });
}

/**
 * Return vendors from KitOptions[vendors]
 * @param kit
 */
export function getVendorsFromKit(kit:any) {
  return kit.vendors.map((vendor) => vendor.name);
}


export function throttle(func: (any) => any, ms: number) {
  let isThrottled = false,
    savedArgs,
    savedThis;

  function wrapper() {

    if (isThrottled) {
      savedArgs = arguments;
      savedThis = this;
      return;
    }

    func.apply(this, arguments);

    isThrottled = true;

    setTimeout(function() {
      isThrottled = false;
      if (savedArgs) {
        wrapper.apply(savedThis, savedArgs);
        savedArgs = savedThis = null;
      }
    }, ms);
  }

  return wrapper;
}

export  function loadRecaptchaIfNotPresent() {
  return new Promise<void>((resolve, reject)=> {
    if (!window.grecaptcha) {
      let timeout = setTimeout(() => {
        reject();
      }, 10000);


      let name = makeid(8);
        window[name] = function(){
        resolve();
        window[name]=undefined
        clearTimeout(timeout)
      }
      loadScript("https://www.google.com/recaptcha/api.js?onload="+name )
      
    }
  })
  
}

/**
 * Get recapcha token
 * @param id
 * @returns
 */
 export async function validateRecaptcha(container: HTMLElement): Promise<string> {
   await loadRecaptchaIfNotPresent();
  let rand = "captcha-" + makeid(5);
  let element = document.createElement("div");
  let element_number = 0;
  element.id = rand;
  container.appendChild(element);

  return new Promise((resolve, reject) => {
    var onSubmit = function (token) {
      // Reset captcha
      grecaptcha.reset(element_number);
      // Return token
      resolve(token);
      element.remove();
    };

    var onError = function () {
      // Reset captcha
      grecaptcha.reset(element_number);
      reject();
      // Reset captcha
      element.remove();
    };

    try {
      // Render captcha
      element_number = grecaptcha.render(element, {
        sitekey: "6LconrceAAAAANL0ht2OfJ6m-mqvPzZJoWdmWVup",
        callback: onSubmit,
        size: "invisible",
        "error-callback": onError,
      });
    } catch (err) {}
    // Execute captcha
    grecaptcha.execute(element_number);
  });
}


export function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

/**
 * Waits some time, useful for making stuff
 * @param length amount of time to wait in ms
 */
export function sleep(length: number) {
  return new Promise((resolve,reject) => {
    setTimeout(resolve, length )
  })
}


//this function will work cross-browser for loading scripts asynchronously
function loadScript(src)
{
  return new Promise<void>((resolve,reject) => {
  var s,
      r,
      t;
  r = false;
  s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = src;
  s.onload = s.onreadystatechange = function() {
    //console.log( this.readyState ); //uncomment this line to see which ready states are called.
    if ( !r && (!this.readyState || this.readyState == 'complete') )
    {
      r = true;
      resolve();
    }
  };
  t = document.getElementsByTagName('script')[0];
  t.parentNode.insertBefore(s, t);})
}